<template>
  <div>
    <b-row class="justify-content-start">
      <b-col md="2" class="w-100" v-if="type == 'BULK'">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-col>
    </b-row>
    <b-row class="mb-5 justify-content-start ml-0">
      <!-- Left section filtre -->
      <b-col cols="4" lg="2" xl="2" class="mt-2 pl-0">
        <b-button class="btnFilter"
          @click="displayFilter = !displayFilter">
          <i v-if="displayFilter" class="fa-light fa-minus"></i>
          <i v-else class="fa-light fa-plus"></i>
          {{ $t('filter.fltr') }}
        </b-button>
      </b-col>
      <b-col cols="4" lg="2" xl="2" class="mt-2">
        <b-button class="btnFilter"
          @click="refreshInbox()">
          <i class="fa-light fa-rotate-right"></i>
          {{ $t('common.rfrsh') }}
        </b-button>
      </b-col>
      <b-col>
      </b-col>
      <b-col cols="4" lg="2" xl="2" class="mt-2" v-if="AccountTBList.length > 0">
         <b-button class="btnFilter_2 ml-3"
           @click="chooseExtractType()">
           <i class="fa-light fa-upload fs-14px"></i>
           <span class="fab-label">{{ $t('account_tb.extract_stats') }}</span>
         </b-button>
       </b-col>
    </b-row>
    <b-row class="min-w-100 justify-content-start align-items-center" >
      <!--Filtre IBAN -->
      <b-col v-if="displayFilter" sm="6" lg="3" cols="12" class="filter-item mb-5">
        <label class="filter-item-title" for="filter-iban">{{ $t('account_tb.name') }}</label>
        <span class="filter-item-content">
          <input v-model.trim="Name"
                 id="filter-iban"
                 type="text"
                 :class="{'filter-item-input': true, 'filter-item-input-complete': Name}"
                 :placeholder="$t('account_tb.name')"
                 style="width: 100%">
        </span>
      </b-col>
    </b-row>
    <b-row class="min-w-100 justify-content-end mb-5 mr-1" v-if="displayFilter">
      <!-- Bouton Effacer et Appliquer -->
      <b-col lg="3" cols="12" class="d-flex flex-row-reverse mt-3">
        <b-button size="sm"
          @click="applyFilter()">
          {{ $t('common.srch') }}
        </b-button>
        <b-button class="mr-3" size="sm"
          @click="clearFilterFields"
          :disabled="!hasInputFilter">
          {{ $t('filter.clr_fltr_field') }}
        </b-button>
      </b-col>
    </b-row>
    <spinner v-if="activateSpinner"></spinner>
    <div v-else-if="AccountTBList.length > 0" style="overflow:auto">
      <chart-pie-stat v-if="AccountTBStat.length > 0" :stat="AccountTBStat"></chart-pie-stat>
      <div v-else class="d-flex justify-content-center">
      <span class="noResult">
        {{ $t('account_tb.no_data') }}
      </span>
      </div>
      <b-table hover
        class="table table-striped mt-5"
        :fields="fields"
        :items="AccountTBList" select-mode="single"
        :empty-text="$t('common.security.no_result')"
        @row-clicked="seeAccountTBDetails">
        <template #cell(IsRVM)="data">
          <div class="text-ellipsis">
            <i v-if="data.item.IsRVM == 1"
              class="fas fa-check bg-success text-white"
              style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
            </i>
            <i v-else
              class="fas fa-minus  bg-secondary text-white"
              style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
            </i>
          </div>
        </template>
        <template #cell(SessionTest)="data"><div class="text-ellipsis">{{getSessionTestStatus(data.item.StartDate, data.item.EndDate, data.item) }}</div></template>
        <template #cell(Progress)="data"><div class="text-ellipsis">{{ data.item.TotalOk == '' || data.item.TotalOk == 0 ? 0 : ((data.item.TotalOk/data.item.TotalTest)* 100).toFixed(2) }} %</div></template>
        <template #cell(RenewToken)="data">
          <div class="col-lg-4 col-xl-4 col-2" style="display: inline-flex; justify-content: center; align-items: center;">
              <button
                type="button"
                class="btn btn-primary"
                @click="renewToken(data)">
                {{$t("account_tb.renewToken")}}
              </button>
          </div>
        </template>
      </b-table>
    </div>
    <div v-else class="d-flex justify-content-center">
      <span class="noResult">
        {{ $t('common.no_result') }}
      </span>
    </div>
<!--    <b-row class="mt-5">-->
<!--      <b-col cols="12">-->
<!--        <cm-pagination-->
<!--          :maxResultsByPage="paginationObject.maxResults"-->
<!--          :firstIndex="paginationObject.firstIndex"-->
<!--          :nbResultsTotal="paginationObject.nbResultsTotal"-->
<!--          :refreshEvent="paginationObject.refresh">-->
<!--        </cm-pagination>-->
<!--      </b-col>-->
<!--    </b-row>-->
  </div>
</template>

<script>
import conf from '../../config/config.dev.js'
import moment from 'moment'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import {downloadFileWithDefinedHeaders} from '@/helpers/download'
import BackButton from '@/components/common/backButton.vue'
import ChartPieStat from '@/pages/accountTB/ChartPieStat.vue';

import checkIconBase64KO from '@/assets/static/times-circle-solid.png'
import checkIconBase64OK from '@/assets/static/check-circle-solid.png'
import EPCLogo from '@/assets/EPC_logo.png'

import { jsPDF } from 'jspdf'
import 'jspdf-autotable'

export default {
  name: 'AccountPage',
  components: {
    ChartPieStat,
    BackButton,
    'cm-pagination': Pagination,
    'spinner': Spinner,
    'datetime-picker-custom': dateTimePicker,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    type: {
      default: 'DDV',
      type: String
    },
    id: {
      default: 'NULL',
      type: String
    }
  },
  computed: {
    canUserRenewToken() {
      return this.$engine.rights.rightIs('company_import', true) || this.$engine.rights.rightIs('company_import', true)
    },
    fields () {
      let fields
      fields = [
        { key: 'Name', label: this.$i18n.t('account_tb.name'), class: 'text-center', sortable: false },
        { key: 'IsRVM', label: this.$i18n.t('account_tb.is_rvm'), class: 'text-center', sortable: false },
        { key: 'SessionTest', label: this.$i18n.t('account_tb.session_test.session_test_title'), class: 'text-center', sortable: false },
        { key: 'Progress', label: this.$i18n.t('account_tb.progress_percentage'), class: 'text-center', sortable: false },
        { key: 'RenewToken', label: this.$i18n.t('account_tb.renew_token'), class: 'text-center', sortable: false },
      ]

      return fields
    },
    company_nameDirection () {
      return ((this.sortField === 'company_name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    statusVerificationDirection () {
      return ((this.sortField === 'statusVerification' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    hasInputFilter () {
      if (
          this.Name ||
          this.Result ) {
        return true
      }
      return false
    },
  },
  data () {
    return {
      isMandatoryFieldMiss: true,
      activateSpinner: false,
      displayFilter: false,
      filterBy: '',
      hasDefaultFilter: false,
      statusVerification: '',
      VopProvider: '',
      Result: '',
      Name: '',
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      AccountTBList: [],
      AccountTBStat: [],
    }
  },
  created () {
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start',
      navTitle: 'Tracking',
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)

    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.tracking.cleanFilterCondition()
  },
  methods: {
    activateDetail (id) {
      let that = this
      loadPage(that, {url: '/accountTBdetails/' + id})
    },
    applyFilter (filterConditions = {}) {
      if(this.tabName !== 2 && this.dateBegin === '') {
        this.isMandatoryFieldMiss = false
        return
      }
      this.isMandatoryFieldMiss = false
      this.AccountTBList = []
      this.AccountTBStat = []
      let that = this
      this.filterTypeGet = 'list'

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['maxResults'] = 15
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      this.$engine.tracking.cleanFilterCondition()

      filterConditions.Name = this.Name.trim()

      this.$engine.accountTB.getAccountTB(
        filterConditions
      ).then(resp => {
        let requests = {}
        if (resp.data && resp.data.accounts.length > 0) {
          that.paginationObject.nbResultsTotal = resp.data.countAccountTBs
          that.paginationObject.nbResults = resp.data.accounts.length
          requests = resp.data
          that.updateInbox(requests)
        }
        // this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    chooseExtractType () {
      let that = this
      this.$f7.modal({
        title: that.$t('account_tb.choose_extract_type'),
        buttons: [
          {
            text: 'CSV',
            onClick: function () {
              that.extractCSV()
            }
          },
          {
            text: 'PDF',
            onClick: function () {
              that.extractPDF()
            }
          },
          {
            text: that.$i18n.t('common.cncl'),
            onClick: function () {
            }
          }
        ]
      })
    },
    clearFilterFields () {
      this.isMandatoryFieldMiss = true
      this.paginationObject = {}
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['maxResults'] = 15
      this.paginationObject['nbResultsTotal'] = 0
      this.paginationObject['refresh'] = 'direct-inbox-filtered'
      this.Name = ''
      this.communicateChange()
      this.AccountTBList = []
      this.AccountTBStat = []
      this.applyFilter()
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    extractCSV () {
      let utcOffsetMinutes = moment().utcOffset()
      let utcOffsetHours = utcOffsetMinutes / 60
      let that = this
      this.pageCounter = 0

      let filterConditions = {
        maxResults: this.paginationObject.nbResultsTotal,
        firstIndex: 1,
        extract : 1,
        OffsetUTC: (utcOffsetHours >= 0 ? '+' : '')+ utcOffsetHours,
        Name: this.Name.trim(),
      }

      this.$engine.accountTB.getAccountTB(
        filterConditions
      ).then(resp => {
        that.$f7.hidePreloader()

        let csvContent = ''

        let firstLine = this.$i18n.t('account_tb.name') + ';' +
          this.$i18n.t('account_tb.is_rvm') + ';' +
          this.$i18n.t('account_tb.session_test.session_test_title') + ';' +
          this.$i18n.t('account_tb.progress_percentage')

        let lines = [firstLine]
        if (resp.data && resp.data.accounts) {
          resp.data.accounts.forEach(account => {
            let status = this.getSessionTestStatus(account.StartDate, account.EndDate, account)
            let percentage = account.TotalOk === '' ? '0' : (((parseInt(account.TotalOk) / parseInt(account.TotalTest))* 100).toFixed(2)).toString() + '%'
            let line = account.Name + ';' + account.IsRVM + ';' + status + ';' + percentage
            lines.push(line)
          })
        }

        const linkSource = 'data:text/csv;charset=utf-8,' + encodeURIComponent(lines.join("\n"))
        const downloadLink = document.createElement('a')
        const fileName = this.$t('Webheader.account_tb') + '_' + moment().format('YYYYMMDDHHmmss') + '.csv'

        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()

        this.$f7.alert('', this.$i18n.t('account_tb.exprt_succ', {filename: fileName}))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    svgToBase64Image(url) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = function () {
          const canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          const ctx = canvas.getContext('2d')
          if (!ctx) return reject('Canvas context null')
          ctx.drawImage(img, 0, 0)
          resolve(canvas.toDataURL('image/png'))
        }
        img.onerror = reject
        img.src = url
      })
    },
    extractPDF () {
      let utcOffsetMinutes = moment().utcOffset()
      let utcOffsetHours = utcOffsetMinutes / 60
      let that = this
      this.pageCounter = 0

      let filterConditions = {
        maxResults: this.paginationObject.nbResultsTotal,
        firstIndex: 1,
        extract : 1,
        OffsetUTC: (utcOffsetHours >= 0 ? '+' : '')+ utcOffsetHours,
        Name: this.Name.trim(),
      }

      this.$engine.accountTB.getAccountTB(filterConditions)
      .then(resp => {
        that.$f7.hidePreloader()

        let pdfCanva = document.getElementById('pie-chart')
        var pdf, pageWidth, pageHeight, widthRatio, heightRatio, ratio, canvasWidth, canvasHeight, marginX, marginY, csvFileData
        // Titre du rapport
        pdf = new jsPDF('p', 'px', 'a4')


        pageWidth = pdf.internal.pageSize.getWidth()
        pageHeight = pdf.internal.pageSize.getHeight()

        widthRatio = pageWidth / pdfCanva.width
        heightRatio = pageHeight / pdfCanva.height
        ratio = widthRatio > heightRatio ? heightRatio : widthRatio

        canvasWidth = pdfCanva.width * ratio
        canvasHeight = pdfCanva.height * ratio

            this.svgToBase64Image(EPCLogo)
                .then((logoDataUrl) => {

                  pdf.addImage(logoDataUrl, 'PNG', 14, 10, 80, 80)

                  pdf.setFontSize(18)
                  pdf.text(this.$t('Webheader.account_tb'), 14, 120)


                  let info = this.$engine.accounts.get()
                  let userAccounts
                  let userAccountId
                  userAccounts = info[0].userAccts
                  userAccountId = info[0].userAccountId
                  const userAccount = userAccounts.filter((account) => account.id === userAccountId)
                  const userLogin = userAccount[0].name

                  const companyName = this.$engine.user.get().name

                  const exportDate = moment().format('DD/MM/YYYY HH:mm')
                  const userName = userLogin || 'User unknown'
                  const userCompany = companyName || 'Entreprise unknown'
                  pdf.setFontSize(10)
                  pdf.text(`Exported on ${exportDate} by ${userName} - ${userCompany}`, pageWidth - 14, 120, { align: 'right' })


                  marginX = 0
                  marginY = 130

                  pdf.setFontSize(18)

                  var newCanvas = document.createElement('canvas')
                  var context = newCanvas.getContext('2d')
                  newCanvas.width = pdfCanva.width
                  newCanvas.height = pdfCanva.height
                  // apply the old canvas to the new one
                  context.drawImage(pdfCanva, 0, 0)

                  context = newCanvas.getContext('2d')
                  context.save()
                  context.globalCompositeOperation = 'destination-over'
                  context.fillStyle = 'white'
                  context.fillRect(0, 0, newCanvas.width, newCanvas.height)
                  context.restore()

                  pdf.addImage(newCanvas, 'JPG', marginX, marginY, canvasWidth, canvasHeight)

                  const tableData = resp.data.accounts.map(account => [
                    account.Name,
                    account.IsRVM,
                    that.getSessionTestStatus(account.StartDate, account.EndDate, account),
                    (account.TotalOk == '' ? 0 : ((parseInt(account.TotalOk)/parseInt(account.TotalTest))*100).toFixed(2)).toString() + '%'
                  ])

                  pdf.autoTable({
                    head: [[this.$t('account_tb.name'), this.$t('account_tb.is_rvm'), this.$t('account_tb.session_test.session_test_title'), this.$t('account_tb.progress_percentage')]],
                    body: tableData,
                    startY: canvasHeight + marginY + 25,
                    theme: 'striped',
                    margin: { left: 14, right: 14 },
                    styles: { fontSize: 10 },
                    willDrawCell: (data) => {
                      if (data.column.index === 1 && ['0','1'].includes(data.cell.raw)) { // Vérifie si on est dans la colonne "Statut"
                        data.cell.text = [" "]; // Remplace le texte par un espace invisible
                      }
                    },
                    didDrawCell: (data) => {
                      if (data.column.index === 1) {
                        let iconSizeX = 30
                        let iconSizeY = 8
                        if (data.cell.raw === '0') {
                          const xCenter = data.cell.x + (data.cell.width - iconSizeX) / 2;
                          const yCenter = data.cell.y + (data.cell.height - iconSizeY) / 2;
                          pdf.addImage(checkIconBase64KO, "PNG", xCenter, yCenter, 6, 6);
                          data.cell.text = []
                        } else if (data.cell.raw === '1') {
                          const xCenter = data.cell.x + (data.cell.width - iconSizeX) / 2;
                          const yCenter = data.cell.y + (data.cell.height - iconSizeY) / 2;
                          pdf.addImage(checkIconBase64OK, "PNG", xCenter, yCenter, 6, 6);
                          data.cell.text = []
                        }
                      }
                    }
                  })

                  const pageCount = pdf.internal.getNumberOfPages();
                  for (let i = 1; i <= pageCount; i++) {
                    pdf.setPage(i);
                    pdf.setFontSize(10);
                    pdf.text('Dealprudence - EPC ART platform for VOP', 150, pdf.internal.pageSize.height - 10);
                    pdf.text(`Page ${i} / ${pageCount}`, pdf.internal.pageSize.width - 14, pdf.internal.pageSize.height - 10, { align: 'right' });
                  }


                  const fileName = that.$t('Webheader.account_tb') + '_' + moment().format('YYYYMMDDHHmmss') + '.pdf'
                  pdf.save(fileName)

                })


      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getSessionTestStatus (StartDate, EndDate, item) {
      const now = new Date()

      if (item.UserCount == 0) {
        return this.$t('account_tb.session_test.no_enrollment')
      }

      if (!StartDate || !EndDate) {
        return this.$t('account_tb.session_test.scheduled_not_planned')
      }

      const start = new Date(StartDate)
      const end = new Date(EndDate)

      if (end < now) {
        return this.$t('account_tb.session_test.scheduled_not_planned')
      }

      if (start > now) {
        return this.$t('account_tb.session_test.scheduled_upcoming')
      }

      if(((item.TotalOk/item.TotalTest)* 100).toFixed(2) == '100.00'){
        return this.$t('account_tb.session_test.all_test_ok')
      }

      return this.$t('account_tb.session_test.in_progress')
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onRefresh (noAttach = false, index = 1) {
      let that = this
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions = {
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
        Name: this.Name.trim(),
      }

      this.$engine.accountTB.getAccountTB(
        filterConditions
      ).then(resp => {
        this.AccountTBList = []
        this.AccountTBStat = []
        let requests = {}
        if (resp.data && resp.data.accounts.length > 0) {
          that.paginationObject.nbResultsTotal = resp.data.countAccountTBs
          that.paginationObject.nbResults = resp.data.accounts.length
          requests = resp.data
          that.updateInbox(requests, noAttach)
          that.$f7.pullToRefreshDone()
          that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        }
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    refreshInbox () {
      this.onRefresh()
    },
    renewToken (data) {
      let IdUserAccount = data.item.IdAccount
      let codeLanguage = this.$i18n.locale.toUpperCase()
      let that = this
      this.showLoader = true
      this.$engine.accountTB.renewToken(IdUserAccount,codeLanguage)
        .then(resp => {
          that.showLoader = false
          let titleMod = that.$t('account_tb.modal_renewToken_title')
          let textMod = that.$t('account_tb.modal_renewToken_text')
          textMod = textMod.replace('{token}',resp.data.newToken)
          textMod = textMod.replace('{user}',resp.data.userName)
          textMod = textMod.replace('{email}',resp.data.emailUser)
          that.$f7.modal({
            title: titleMod,
            text: '<i class="icon fa-solid fa-check text-success"></i>'+textMod
          })
          setTimeout(function () {
            that.$f7.closeModal()
          }, 4000)
        })
        .catch(err => {
          let title = that.$t('error')
          let description = that.$t('errorHappend')
          if (err && err.response && err.response.statusText && err.response.data && err.response.data.errorDescription) {
            title = err.response.statusText
            description = err.response.data.errorDescription
          }
          // that.$bus.$emit('sm-notif', {title: title, description: description, error: true, encoded: true})
          this.$f7.alert(description, title)
          that.showLoader = false
          if (err && err.response && err.response.status >= 410 && err.response.status <= 422) {
            this.$emit('close')
            that.$bus.$emit('logout')
          }
        })

    },
    reOrderBy (column) {
      this.AccountTBList = []
      this.AccountTBStat = []
      let that = this
      if (this.sortField === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortField = column
        switch (column) {
          case 'dateAction':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions

      this.$engine.accountTB.getAccountTB(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.countAccountTBs
        that.paginationObject.nbResults = resp.data.tracks.length
        requests = resp.data
        that.updateInbox(requests, false)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    seeAccountTBDetails (items) {
      this.activateDetail(items.IdAccount)
    },
    updateInbox (requests, noAttach = false) {
      this.AccountTBList = requests.accounts
      this.AccountTBStat = requests.accounts
      if (requests.accounts.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    }
  }
}
</script>

<style scoped>
.result-vignette {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
}

.result-mtch {
  background-color: rgba(0, 143, 57, 0.8);
}

.result-nmtc {
  background-color: rgba(204, 0, 0, 0.8);
}

.result-cmtc {
  background-color: rgba(230, 159, 0, 0.8);
}

.result-noap {
  background-color: rgba(153, 153, 153, 0.8);
}
</style>
